// extracted by mini-css-extract-plugin
module.exports = {"content":"StandardLayout_content__2Onqp"};